import { RETURN_PREFERENCE_LIMIT } from '../shared/contracts.js';

export function returnPreferenceLabel(value: number): string {
  if (value === 0) return 'Neutral';
  const roads = value < 0 ? 'the same roads' : 'different roads';
  return Math.abs(value) === RETURN_PREFERENCE_LIMIT
    ? `Strongly prefer ${roads}`
    : `Prefer ${roads} · ${Math.abs(value)}/${RETURN_PREFERENCE_LIMIT}`;
}
